enum ErrorType {
    MANIFEST_REQUEST_FAILED_DURING_LOAD = 'MANIFEST_REQUEST_FAILED_DURING_LOAD',
    SEGMENT_REQUEST_FAILED_DURING_LOAD = 'SEGMENT_REQUEST_FAILED_DURING_LOAD',
    MANIFEST_REQUEST_FAILED_DURING_PLAYBACK = 'MANIFEST_REQUEST_FAILED_DURING_PLAYBACK',
    SEGMENT_REQUEST_FAILED_DURING_PLAYBACK = 'SEGMENT_REQUEST_FAILED_DURING_PLAYBACK',
    REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
    UNSUPPORTED_FORMAT = 'UNSUPPORTED_FORMAT',
    CERTIFICATE_REQUEST_FAILED = 'CERTIFICATE_REQUEST_FAILED',
    CDM_UNAVAILABLE = 'CDM_UNAVAILABLE',
    LICENSE_REQUEST_FAILED = 'LICENSE_REQUEST_FAILED',
    PLAYBACK_INTERRUPTED_CONNECTION_LOST = 'PLAYBACK_INTERRUPTED_CONNECTION_LOST',
    UNKNOWN_SOLUTION_ERROR = 'UNKNOWN_SOLUTION_ERROR',
    CONSUMER = 'CONSUMER',
    NONE = 'NONE'
}

export default ErrorType;